var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('edit-user-profile-form',{attrs:{"user-email":_vm.$store.getters['account/email']},on:{"notifChanged":_vm.onNotifChanged}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }